"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKToolbarSelect = void 0;
var React = __importStar(require("react"));
var components_1 = require("../../../components");
var common_1 = require("../../../common");
var hooks_1 = require("../../../common/hooks");
/**
 * Component representing a leaf-level item of a menu, which returns a data payload of type T on click
 */
var GKToolbarSelect = function (props) {
    var uniqueId = (0, common_1.usePersistentId2)(props.id);
    var _a = (0, hooks_1.useMergedProps)(props, {
        _gkComponentIdentifier: "gk-toolbar-select",
        className: "gk-icon-button gk-toolbar-action",
        "data-qa": props["data-qa"] || "gk-toolbar-select",
        id: uniqueId,
    }), icon = _a.icon, selectItems = _a.selectItems, onChange = _a.onChange, selectedItem = _a.selectedItem, tooltip = _a.tooltip, passThroughProps = __rest(_a, ["icon", "selectItems", "onChange", "selectedItem", "tooltip"]);
    var _b = React.useState(selectedItem), selected = _b[0], setSelected = _b[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(components_1.GKSelect, __assign({}, passThroughProps, { placeholder: React.createElement(components_1.GKIcon, { name: icon }), selectedItem: selected, onChange: function (item) {
                onChange();
                setSelected(item !== undefined ? item : undefined);
            } }), selectItems.map(function (item) { return (React.createElement(components_1.GKOption, __assign({}, item, { key: item.id, label: React.createElement(components_1.GKIcon, { name: item.icon }), value: item.id }),
            React.createElement("div", { className: "d-flex" },
                React.createElement(components_1.GKIcon, { name: item.icon }),
                item.content))); })),
        tooltip && React.createElement(components_1.GKTooltip, { target: uniqueId }, tooltip)));
};
exports.GKToolbarSelect = GKToolbarSelect;
